export default __webpack_public_path__ + "static/media/service_custom_mobile_app_development.2f2a4ba1.png";